import i18n from '@/i18n';
import { TranslateResult } from 'vue-i18n';

type TErrorMessage = string | TranslateResult;
type TErrors = Array<TErrorMessage>;
type TFieldValue =
  | string
  | number
  | null
  | undefined
  | Array<string | number | undefined>;

function isExist(errors: TErrors, message: TErrorMessage): void {
  if (!errors.includes(message)) {
    errors.push(message);
  }
}
function clearErrors(errors: TErrors, message: TErrorMessage): void {
  if (!errors.length) return;

  const errorIndex = errors.indexOf(message);
  if (errorIndex !== -1) {
    errors.splice(errorIndex, 1);
  }
}

// Не пустая строка, не null, не undefined
export function Required(value: TFieldValue, errors: TErrors) {
  const message = i18n.t('errors.required');
  if (value === undefined || value === null || String(value).trim() === '') {
    isExist(errors, message);
    return message;
  }
  clearErrors(errors, message);
}

// Не пустая строка
export function NotEmpty(value: TFieldValue, errors: TErrors): void {
  const message = i18n.t('errors.empty');
  if (value === undefined || value === null || String(value).trim() === '') {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

// Только цифры
export function OnlyNumbers(value: TFieldValue, errors: TErrors): void {
  const validRegex = /^\d+$/;
  const message = i18n.t('errors.onlyNumbers');
  if (String(value) && !validRegex.test(String(value))) {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

// Первый символ a-z остальные a-z 0-9 - _
export function ValidSelector(value: TFieldValue, errors: TErrors): void {
  const validRegex = /^[a-z][a-z0-9-_]+$/;
  const message = i18n.t('errors.validSelector');
  if (String(value) && !validRegex.test(String(value))) {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

// Первый символ # потом a-z остальные a-z 0-9 - _
export function ValidSelectorId(value: TFieldValue, errors: TErrors): void {
  const validRegex = /^[#][a-z][a-z0-9-_]+$/;
  const message = i18n.t('errors.validSelectorId');
  if (String(value) !== '' && !validRegex.test(String(value))) {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

// Первый символ . потом a-z остальные a-z 0-9 - _
export function ValidSelectorClass(value: TFieldValue, errors: TErrors): void {
  const validRegex = /^[.][a-z][a-z0-9-_]+$/;
  const message = i18n.t('errors.validSelectorClass');
  if (String(value) && !validRegex.test(String(value))) {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

// https:// доменное имя
export function ValidDomain(value: TFieldValue, errors: TErrors): void {
  const validRegex =
    /^(https?:\/\/)?[a-zA-Z0-9][a-zA-Z0-9-_.]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z0-9]{2,})+/;
  const message = i18n.t('errors.validDomain');
  if (String(value) && !validRegex.test(String(value))) {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

// Число больше ноля
export function NumberMoreZero(value: TFieldValue, errors: TErrors): void {
  const message = i18n.t('errors.numberMoreZero');
  if (Number(value) <= 0) {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

// Число больше или равно нолю
export function NumberMoreEqualZero(value: TFieldValue, errors: TErrors): void {
  const message = i18n.t('errors.numberMoreEqualZero');
  if (Number(value) < 0) {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

// Число меньше 100
export function NumberLess100(value: TFieldValue, errors: TErrors): void {
  const message = i18n.t('errors.numberLess100');
  if (Number(value) < 100) {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

// Число больше 0 и меньше 100
export function NumberMore0Less100(value: TFieldValue, errors: TErrors): void {
  const message = i18n.t('errors.numberMore0Less100');
  const numberValue = Number(value);
  if (numberValue <= 0 || numberValue >= 100) {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

// Число больше чем заданно
export function LengthMoreThen(
  value: TFieldValue,
  errors: TErrors,
  maxLength: number
): void {
  const message = i18n.t('errors.maxLength');
  if (String(value).length > maxLength) {
    isExist(errors, message);
    return;
  }
  clearErrors(errors, message);
}

const VALIDATION = {
  required: Required,
  notEmpty: NotEmpty,
  onlyNumbers: OnlyNumbers,
  validSelector: ValidSelector,
  validSelectorId: ValidSelectorId,
  validSelectorClass: ValidSelectorClass,
  validDomain: ValidDomain,
  numberMoreZero: NumberMoreZero,
  numberMoreEqualZero: NumberMoreEqualZero,
  numberMore0Less100: NumberMore0Less100,
  numberLess100: NumberLess100,
  lengthMoreThen: LengthMoreThen,
};

export default VALIDATION;
